import type { EventListFilters } from '@vlabs/monokit/entities/events/filters';

const GEOLOCATION_FIELDS: (keyof EventListFilters)[] = [
  'cities', 'areas', 'districts', 'streets', 'house_numbers',
  'origin_longitude', 'longitude_delta', 'origin_latitude', 'latitude_delta',
];

const hasArrayValues = (value: unknown): boolean => Array.isArray(value) && value.length > 0;

export const hasLocationFilters = (filters: EventListFilters): boolean => (
  GEOLOCATION_FIELDS.some((field) => filters[field] !== undefined)
);

export interface WorkspaceFilterGroupCounts {
  general: number;
  face: number;
  body: number;
}

export function getWorkspaceFilterGroupCounts(filters: EventListFilters): WorkspaceFilterGroupCounts {
  let general = 0;
  if (hasArrayValues(filters.sources)) general += 1;
  if (hasArrayValues(filters.handler_ids)) general += 1;
  if (filters.top_matching_candidates_label) general += 1;
  if (filters.top_similar_object_similarity__gte !== undefined
    || filters.top_similar_object_similarity__lt !== undefined) general += 1;
  if (hasLocationFilters(filters)) general += 1;

  let face = 0;
  if (filters.gender !== undefined) face += 1;
  if (filters.age__gte !== undefined || filters.age__lt !== undefined) face += 1;

  let body = 0;
  if (filters.apparent_gender !== undefined) body += 1;
  if (filters.apparent_age__gte !== undefined || filters.apparent_age__lt !== undefined) body += 1;
  if (hasArrayValues(filters.upper_clothing_colors) || hasArrayValues(filters.sleeve_lengths)) body += 1;
  if (hasArrayValues(filters.lower_garment_colors) || hasArrayValues(filters.lower_garment_types)) body += 1;
  if (hasArrayValues(filters.shoes_apparent_colors)) body += 1;
  if (hasArrayValues(filters.headwear_apparent_colors) || hasArrayValues(filters.headwear_states)) body += 1;
  if (hasArrayValues(filters.backpack_states)) body += 1;

  return { general, face, body };
}

export function countAppliedWorkspaceFilters(filters: EventListFilters): number {
  const { general, face, body } = getWorkspaceFilterGroupCounts(filters);
  return general + face + body;
}
